<!-- 资料下载组件 -->
<template>
    <div class="data_download">
        <p class="title"><img :src="require('@/common/images/special/zlxz.png')" alt=""> 资料下载</p>
        <div class="list" v-if="!loading">
            <div class="item" v-for="(item, index) in list" :key="index">
                <div class="data_name">{{item.docname}}</div>
                <div class="download_btn" @click="download(item)">下载</div>
            </div>
        </div>
        <skeleton type='listcom' v-else active :options="{row: 7, lineHight: 20}" />
    </div>
</template>

<script>
import {downloaddocument} from 'api/special'
import {mapActions, mapGetters} from 'vuex'
export default {
    data() {
        return {

        }
    },
    props: ['list', 'loading'],
    // 生命周期 - 创建完成（访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        download(item) {
            if (this.user.isLogin) {
                this.setLoading(true)
                downloaddocument({
                    data: {documentid: item.documentid},
                    name: item.orgfilename,
                    success: res => {
                        this.setLoading(false)
                        console.log(res)
                    },
                    error: res => {
                        this.setLoading(false)
                        this.$message.error(res.msg)
                    }
                })
            } else {
                this.setLoginPop(true)
            }
        },
        ...mapActions([
            'setLoading',
            'setLoginPop'
        ])
    },
    computed: {
        ...mapGetters(['user'])
    }
}
</script>
<style scoped lang='scss'>
/* @import url(); 引入css类 */
    .data_download {
        width: 260px;
        height: 331px;
        margin-bottom: 30px;
        .title {
            // border-left: 3px solid #409EFF;
            padding-left: 5px;
            font-size: 18px;
            font-weight: bold;
            line-height: 25px;
            margin-bottom: 20px;
            display: flex;
            align-items: center;
            border-bottom: 1px solid #E5E5E5;
            padding-bottom: 10px;
            img {
                width: 16px;
                height: 16px;
                margin-right: 5px;
            }
        }
        .list {
            .item {
                display: flex;
                align-items: center;
                margin-bottom: 12px;
                .data_name {
                    width: 230px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    margin-right: 6px;
                    font-size: 14px;
                    line-height: 24px;
                }
                .download_btn {
                    cursor: pointer;
                    color: #409EFF;
                    font-size: 12px;
                }
            }
        }
        .contianer_S8Y9lJLI {
            height: 90%;
        }
    }
</style>